<template>
    <h1>404 Page Not Found</h1>
</template>

<script>
export default {
    name: "PageNotFound",
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped>

</style>